<template>
	<div class="modal is-active">
		<div class="modal-background" @click="$emit('close')"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<h5 class="modal-card-title title is-5">
					{{ translations['title-confirm'] }}
				</h5>
				<button type="button" class="delete" aria-label="close" @click="$emit('close')"></button>
			</header>
			<section class="modal-card-body">
				{{ message }}
			</section>
			<footer class="modal-card-foot">
				<div class="container">
					<div class="columns is-multiline">
						<div class="column is-half">
							<button class="button is-fullwidth" @click.prevent="$emit('close')">{{ translations.cancel }}</button>
						</div>
						<div class="column is-half">
							<input @click="$emit('confirm')"
								   type="submit" class="button is-success is-fullwidth track-action"
								   :value="translations.confirm"
								   data-ta-event="clientarea-track.employee.cards.card-activation.confirm"
								   data-ta-action="Click"
								   data-ta-label="Employee-page – Cards – Confirm card-activation"
								   data-ta-page-name="EmployeeOverviewPage"
							>
						</div>
					</div>
				</div>
			</footer>
		</div>
	</div>
</template>

<script>
	export default {
		name: "confirm-card-activation",
		props:
		[
			'translations',
			'card',
			'employeeName'
		],
		data ()
		{
			return {
				message: this.translations.message.replace(':name', this.employeeName).replace(':number', this.card.number)
			}
		}
	}
</script>
